import {ChangeDetectionStrategy, Component, computed, DestroyRef, Inject, Injectable, Injector, input, signal, viewChild, viewChildren} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {EMPTY, filter, firstValueFrom, Observable, switchMap, tap} from "rxjs";
import {MatTree, MatTreeModule} from "@angular/material/tree";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatButtonModule} from "@angular/material/button";
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {ArkivFilnodeModell, ArkivMappenodeModell, ArkivnodeId, ArkivNodeModell, DokumentId, DokumentVersjonModell, EnkelGruppeModell, GruppeId, OppdaterMappeSpesifikasjon, SigneringStatus} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {takeUntilDestroyed, toObservable} from "@angular/core/rxjs-interop";
import {DokumentListevisningKomponent} from "../../../dokument/komponenter/dokument-listevisning/dokument-listevisning";
import {MatDrawerToggleResult, MatSidenavContainer, MatSidenavModule} from "@angular/material/sidenav";
import {DelegerteDokumentDetaljerOperasjoner, DelegerteDokumentDetaljerOperasjoner_DI_TOKEN, DokumentDetaljerKomponent} from "../../../dokument/komponenter/dokument-detaljer/dokument-detaljer";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatMenuTrigger} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {ArkivmappeListevisningKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-listevisning/arkivmappe-listevisning";
import {ArkivmappeKortvisningKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-kortvisning/arkivmappe-kortvisning";
import {DokumentKortvisningKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-kortvisning/dokument-kortvisning";
import {KlikkMedStopPropagationDirektiv} from "web-ng2/delt/direktiver/klikkMedStopPropagation/klikkMedStopPropagation";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {grupperGruppertPåOrganisasjonsnavn} from "felles-ng2/modell/gruppeModellHjelpere";
import {GruppeLogoKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-logo/gruppe-logo";
import {Fil, Mappe, Node, NodeAvhengigheter, Rot} from "web-ng2/moduler/arkiv/komponenter/arkiv-trevisning/node";
import {Appkonfigurasjon} from "felles-ng2/tjenester/Appkonfigurasjon";
import {ArkivmappeMenyKomponent, DelegerteArkivmappeMenyOperasjoner, DelegerteArkivmappeMenyOperasjoner_DI_TOKEN} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-meny/arkivmappe-meny";
import {erFilNode, erOrganisasjonsrotMappe, kanArkivnodeRedigeres, kanNyNodeLeggesTil, opprettOrganisasjonsrotMappe, stiTilNode} from "felles-ng2/modell/arkivModellHjelpere";
import {ArkivmappeSkjemaKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-skjema/arkivmappe-skjema";
import {ArkivDatatjeneste, ArkivMappenodeDLM} from "felles-ng2/tjenester/datalager/ArkivDatatjeneste";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {HttpEvent} from "@angular/common/http";
import {EksisterendeDokument, FilopplastingAvhengigheter, Opplastinger, SekvensiellFilopplasting} from "felles-ng2/tjenester/filopplasting/SekvensiellFilopplasting";
import {erIkkeNil, erNil, gjørDersomIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MatDialog} from "@angular/material/dialog";
import {DokumentOpplastingKortvisningKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-opplasting-kortvisning/dokument-opplasting-kortvisning";
import {verifiserErSann} from "felles-ng2/støttefunksjoner/antakelser";
import {fadeInnUtAnimasjon} from "web-ng2/delt/animasjoner";
import {DokumentOpplastingFeilDialogKomponent, FilMedUgyldigMimetype} from "web-ng2/moduler/dokument/modale/dokument-opplasting-feil-dialog/dokument-opplasting-feil-dialog";
import {DokumentOpplastingNyeversjonerDialogKomponent} from "web-ng2/moduler/dokument/modale/dokument-opplasting-nyeversjoner-dialog/dokument-opplasting-nyeversjoner-dialog";
import {DraOgSlippFilDirektiv} from "web-ng2/delt/direktiver/draOgSlippFil/draOgSlippFil";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {TittelKomponent, TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {FilvelgerViaInputFelt} from "felles-ng2/tjenester/filopplasting/FilvelgerViaInputFelt";
import {tillatteMimetyper} from "felles-ng2/støttefunksjoner/mimetyper";
import {erIkkeTomListe, erTomListe, første} from "felles-ng2/støttefunksjoner/lister";
import {FabMenyKomponent} from "web-ng2/delt/komponenter/fab-meny/fab-meny";
import {MatTooltip} from "@angular/material/tooltip";
import {MeldingTilBrukerNg2} from "felles-ng2/tjenester/MeldingTilBrukerNg2";
import {i18n, I18nTekst, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {Varighet} from "felles/tjenester/MeldingTilBruker";
import {Feilhåndteringsstrategi} from "felles-ng2/tjenester/datalager/datatjeneste";
import {filKanLeses} from "felles-ng2/støttefunksjoner/filer";
import {standardFeilmeldingerForErrorRespons} from "felles-ng2/tjenester/ressurser/feilhåndtering";
import {ArkivmappeDetaljerKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-detaljer/arkivmappe-detaljer";
import {NedtrekksmenyKomponent} from "web-ng2/delt/komponenter/nedtrekksmeny/nedtrekksmeny";
import {NedtrekksmenyTriggerForDirektiv} from "web-ng2/delt/komponenter/nedtrekksmeny/nedtrekksmeny-trigger-for";
import {ToggleKlasseVedStickyDirektiv} from "web-ng2/delt/direktiver/toggleKlasseVedSticky/toggleKlasseVedSticky";
import {DelegerteDokumentMenyOperasjoner, DelegerteDokumentMenyOperasjoner_DI_TOKEN} from "web-ng2/moduler/dokument/komponenter/dokument-meny/dokument-meny";
import {NgTemplateOutlet} from "@angular/common";
import {DokumentOpplastingListevisningKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-opplasting-listevisning/dokument-opplasting-listevisning";
import {map} from "rxjs/operators";
import {DelegerteDokumentvisningOperasjoner, DelegerteDokumentvisningOperasjoner_DI_TOKEN, DokumentvisningBasisKomponent} from "web-ng2/moduler/dokument/komponenter/dokumentvisning/DokumentvisningBasisKomponent";
import {DelegerteMappevisningOperasjoner, DelegerteMappevisningOperasjoner_DI_TOKEN} from "web-ng2/moduler/arkiv/komponenter/mappevisning/MappevisningBasisKomponent";
import {ArkivmappeOpprettRedigerDialogKomponent} from "web-ng2/moduler/arkiv/modale/arkivmappe-opprett-rediger-dialog/arkivmappe-opprett-rediger-dialog";
import {BlinkElementDirektiv} from "web-ng2/delt/direktiver/blinkElement/blinkElement";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {ajs_AjsUIRouterGlobals_DI_TOKEN, AjsUIRouterGlobals} from "web-ng2/tjenester/ajs/AjsUIRouterGlobals";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";
import {DataOgMeta, kunRequestRespons, mapTilData} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {Dialog} from "felles-ng2/tjenester/Dialog";
import {DraOgSlippFilAktivertMeldingKomponent} from "web-ng2/delt/direktiver/draOgSlippFil/draOgSlippFilAktivertMelding";
import {DokumentInformasjon, DokumentInformasjonTjeneste} from "felles-ng2/tjenester/DokumentInformasjonTjeneste";

const debug = initDebugger('ArkivTrevisningKomponentKomponent');


/**
 * Viser arkivinnhold
 */
@Component({
    selector: 'arkiv-trevisning',
    templateUrl: 'arkiv-trevisning.html',
    styleUrl: 'arkiv-trevisning.scss',
    host: {
        'data-testid': 'arkiv',
        '[class.viserNodedetaljer]': 'valgtNode() != null'
    },
    animations: [fadeInnUtAnimasjon('0.5s')],
    imports: [
        MatTreeModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        DokumentListevisningKomponent,
        MatSidenavModule,
        DokumentDetaljerKomponent,
        TranslateModule,
        MatMenuTrigger,
        MatButtonToggleGroup,
        MatButtonToggle,
        ReactiveFormsModule,
        ArkivmappeListevisningKomponent,
        ArkivmappeKortvisningKomponent,
        DokumentKortvisningKomponent,
        KlikkMedStopPropagationDirektiv,
        MatProgressSpinner,
        GruppeLogoKomponent,
        ArkivmappeMenyKomponent,
        DokumentOpplastingKortvisningKomponent,
        DraOgSlippFilDirektiv,
        TipsKomponent,
        TittelVerdiKomponent,
        TittelKomponent,
        VerdiKomponent,
        FabMenyKomponent,
        MatTooltip,
        ArkivmappeDetaljerKomponent,
        NedtrekksmenyKomponent,
        NedtrekksmenyTriggerForDirektiv,
        ToggleKlasseVedStickyDirektiv,
        NgTemplateOutlet,
        DokumentOpplastingListevisningKomponent,
        BlinkElementDirektiv,
        HtmlFormatertKomponent,
        DraOgSlippFilAktivertMeldingKomponent
    ],
    providers: [
        //merk at en viktig forutsetning for denne måten å tilgjengeliggjøre sub-komponenters avhengigheter på er at ArkivTrevisningKomponent som injiseres i useFactory
        //er den aktive ArkivTrevisningKomponent instansen, og at det ikke opprette en ny for hver deklarert provider...
        //alternativt kunne {provide:.., useExisting:ArkivTrevisningKomponent} blitt brukt, men her er nedsiden at ArkivTrevisningKomponent da må impl alle Delegert... interfacene - med overlappende metodenavn..
        {provide: DelegerteDokumentMenyOperasjoner_DI_TOKEN, useFactory: (komponent: ArkivTrevisningKomponent) => komponent.delegerteDokumentMenyOperasjoner(), deps: [ArkivTrevisningKomponent]},
        {provide: DelegerteDokumentvisningOperasjoner_DI_TOKEN, useFactory: (komponent: ArkivTrevisningKomponent) => komponent.delegerteDokumentvisningOperasjoner(), deps: [ArkivTrevisningKomponent]},
        {provide: DelegerteDokumentDetaljerOperasjoner_DI_TOKEN, useFactory: (komponent: ArkivTrevisningKomponent) => komponent.delegerteDokumentDetaljerOperasjoner(), deps: [ArkivTrevisningKomponent]},
        {provide: DelegerteArkivmappeMenyOperasjoner_DI_TOKEN, useFactory: (komponent: ArkivTrevisningKomponent) => komponent.delegerteArkivmappeMenyOperasjoner(), deps: [ArkivTrevisningKomponent]},
        {provide: DelegerteMappevisningOperasjoner_DI_TOKEN, useFactory: (komponent: ArkivTrevisningKomponent) => komponent.delegerteMappevisningOperasjoner(), deps: [ArkivTrevisningKomponent]}
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArkivTrevisningKomponent {

    matTree = viewChild.required(MatTree<Node>);
    matDrawerContainer = viewChild.required(MatSidenavContainer);
    /** brukes for å få meny-ikonet til å blinke når bruker klikker på tekstlig ref til meny i hjelpetekst */
    mappeMenyBlink = viewChild<BlinkElementDirektiv>('mappeMenyBlink');
    //i følge dok skulle det være mulig å angi basisklassen 'viewChildren(DokumentvisningBasisKomponent)' - men dette resulterer i en tom array
    //kanskje fordi DokumentvisningBasisKomponent er def med @Component og uttrykket derfor ser etter direkte forekomster av denne komp, og ikke komp som arver fra denne.
    private dokumentKortvisninger = viewChildren(DokumentKortvisningKomponent);
    private dokumentListevisninger = viewChildren(DokumentListevisningKomponent);
    private dokumentDetaljerKomponent = viewChild(DokumentDetaljerKomponent);
    private arkivmappeDetaljerKomponent = viewChild(ArkivmappeDetaljerKomponent);

    /** Mappe som skal vises initielt. Merk at URL-parametrene dokumentId og signer også hensytas, men disses leses rett fra ajsUIRouterGlobals, se {@link #ekspanderStiTil()}*/
    initiellMappeId = input<ArkivnodeId | null>(null);

    /** Mappen vi viser detaljer for i midtre felt */
    aktivMappe = signal<Mappe | null>(null);
    /** Mappe eller dokument vi viser detaljer for i høyre felt, reflekteres også i {@link #valgtMappe} og {@link #valgtDokument} */
    valgtNode = signal<Node | null>(null);
    valgtMappe = computed<Mappe | null>(() => this.valgtNode()?.erMappe() ? this.valgtNode() as Mappe : null);
    valgtDokument = computed<Fil | null>(() => this.valgtNode()?.erFil() ? this.valgtNode() as Fil : null);
    lagrer = asynkArbeidPågårSignal();
    lasterRot = asynkArbeidPågårSignal();
    /** Ventende eller pågående opplastinger av nye dokumenter til arkiv */
    opplastinger = computed(() => this.sekvensiellFilopplasting.ikkeFerdigeSomSignal());
    /** Sann dersom bruker har tilgang til å redigere aktiv mappe */
    kanRedigereAktivMappe = computed(() => this.beregnKanRedigereAktivMappe());
    /** Sann dersom bruker har tilgang til å opprettet mapper og filer i aktiv mappe */
    kanOppretteNodeIAktivMappe = computed(() => this.beregnKanOppretteNodeIAktivMappe());

    visningsmodusKontroll = new FormControl<ArkivVisningsmodus>('kort', {nonNullable: true});

    dataSource: DataSource<Node>;
    rotnode: BrukerRot | null = null; //settes via lastRotmappe
    skjema = ArkivmappeSkjemaKomponent.opprettSkjema();

    /** Håndterer sekvensiell opplasting av dokumenter */
    private sekvensiellFilopplasting:SekvensiellFilopplasting<ArkivFilnodeModell>;
    private opplastingerFeiletPgaUgyldigMimetype: FilMedUgyldigMimetype[] = [];

    constructor(private avhengigheter: ArkivTrevisningKomponentAvhengigheter,
                private kontekst: BrukerkontekstTilbyder,
                private kontekstAdministrasjon: BrukerkontekstAdministrasjon,
                private destroyRef: DestroyRef,
                private navigasjon: Navigasjon,
                private matDialog: MatDialog,
                private meldingTilBruker: MeldingTilBrukerNg2,
                private dialog: Dialog,
                private oversettelser: Oversettelser,
                private filvelger: FilvelgerViaInputFelt,
                injector: Injector,
                @Inject(ajs_AjsUIRouterGlobals_DI_TOKEN) private ajsUIRouterGlobals: AjsUIRouterGlobals) {
        const rotLasting = this.lasterRot.start();
        this.dataSource = {
            connect: (collectionViewer: CollectionViewer): Observable<Node[]> => this.ekspanderteMapper().pipe(rotLasting.avsluttVedLeveranse()),
            disconnect: (collectionViewer: CollectionViewer) => this.rotnode?.terminer()
        }

        //skjul detaljer dersom node vi viser detaljer for ikke lenger er blandt aktiv mappes barn
        //feks som følge av at node har blitt flyttet eller slettet
        toObservable(this.aktivMappe)
          .pipe(
            switchMap(mappe => erIkkeNil(mappe) ? toObservable(mappe.barn, {injector}) : EMPTY),
            map(barn => erIkkeNil(this.valgtNode()) && !barn.some(node => node.node.id == this.valgtNode()!.node.id)),
            filter(valgtNodeFinnesIkkeBlandtBarn => valgtNodeFinnesIkkeBlandtBarn === true))
          .subscribe(() => this.skjulDetaljer());

        //set visningsmodus basert på brukervalg
        gjørDersomIkkeNil(this.kontekst.autentisertBruker().brukervalg.arkivVisningsmodus, modus => this.visningsmodusKontroll.setValue(modus));
        //lagre valgt visningsmodus i brukervalg
        this.visningsmodusKontroll.valueChanges.pipe(takeUntilDestroyed()).subscribe(modus => this.kontekstAdministrasjon.oppdaterBrukervalg({arkivVisningsmodus: modus}));
        this.sekvensiellFilopplasting = SekvensiellFilopplasting.tom<ArkivFilnodeModell>(this.filopplastingAvhengigheter());
    }

    /** Brukes av tree-komponenten for å identifisere node */
    nodenoekkel(): (node: Node) => string {
        return node => node.node.id
    }

    /** Brukes av tree-komponenten for å avgjøre hvilket nivå en node ligger på */
    nivaa(): (node: Node) => number {
        return node => node.nivaa;
    }

    /** Brukes av tree-komponenten for å avgjøre om noder har blitt endret */
    trackBy(): (indeks: number, node: Node) => string {
        return (indeks, node) => node.node.id;
    }

    erMappe = (_: number, node: Node) => node.erMappe;

    /** Håndtere at mappen ble ekspandert/kollapset i mappe-treet.
     * Kalles når bruker klikker på ekspander/minimer-ikonene i mappe-treet */
    async ekspandertEndret(mappe: Mappe, ekspandert: boolean) {
        debug(`ekspandertEndret ${mappe.node.navn}, ${ekspandert} `);
        if (ekspandert) mappe.åpne();
        else mappe.lukk(this.aktivMappe() != mappe); //ikke avslutt mappens abonnemang på endringer i barn dersom dette er aktiv mappe..
    }

    /** Skifter mellom ekspandert/kolapset i mappe-treet, samt markerer angitt mappen som aktiv - dvs at dens innhold vises i midt-del av vindu. */
    togleITreOgVisInnhold(mappe: Mappe) {
        debug(`togleITreOgVisInnhold ${mappe.node.navn}`, this.matTree().isExpanded(mappe))
        this.setAktivMappe(mappe);
        this.matTree().toggle(mappe); //fører til at ekspandertEndret() blir kalt
    }

    /** Sørger for at angitt mappe er ekspandert i mappe-treet, samt markerer angitt mappen som aktiv - dvs at dens innhold vises i midt-del av vindu. */
    ekspanderBarnAvAktivMappe(mappe: Mappe) {
        debug(`ekspanderBarnAvAktivMappe ${mappe.node.navn}`)
        this.setAktivMappe(mappe);
        mappe.sti()
          .filter(mappe => !this.matTree().isExpanded(mappe))
          .forEach(mappe => this.matTree().expand(mappe));
    }

    /** Viser detaljer for angitt node i høyre-del av vindu  */
    async visDetaljerFor(node: Node): Promise<void> {
        debug(`visDetaljerFor ${node.node.navn}`)
        this.valgtNode.set(node);
        if (!this.matDrawerContainer().end!.opened)
            await this.matDrawerContainer().end!.open();
    }

    skjulDetaljer(): Promise<MatDrawerToggleResult> {
        this.valgtNode.set(null);
        return this.matDrawerContainer().end!.close();
    }

    gaaTilForelderMappe() {
        const forelder = this.aktivMappe()!.foreldre()[this.aktivMappe()!.foreldre().length - 1];
        this.togleITreOgVisInnhold(forelder);
    }

    async nyMappe() {
        ArkivmappeOpprettRedigerDialogKomponent.visOpprettMappe(this.matDialog, this.aktivMappe()!.node);
    }

    /** Presenterer bruker med en fil-velger-dialog og registrerer valgte filer under aktiv mappe. */
    async nyttDokument() {
        const valgteFiler = await this.filvelger.presenterFilvelger({tillateMimetyper: tillatteMimetyper(), tillatMultiple: true});
        if (erTomListe(valgteFiler)) return;
        await this.lastOppArkivdokumenter(valgteFiler);
    }

    /** Registrerer angitte filer under aktiv mappe (trigget fra mappe-meny / dra-og-slipp).
     * Merk at vi forutsetter at aktiv mappe er satt og at denne tillater opplasting (se {@link #beregnKanRedigereAktivMappe()}). */
    async filerValgtForOpplasting(filer: File[]) {
        await this.lastOppArkivdokumenter(filer);
    }

    draOgSlippFilStoettet() {
        return () => this.beregnKanOppretteNodeIAktivMappe()
    }

    /** DelegerteDokumentMenyOperasjoner implementasjon.
     * Merk at vi forutsetter at dokumentDetaljer vises når disse kallene skjer, ved klikk på dokument-meny vil klikket på menyen ha ført til at
     * this.visDetaljerFor(..) allerede har blitt kalt, og følgelig vises dokumentDetaljer */
    delegerteDokumentMenyOperasjoner(): DelegerteDokumentMenyOperasjoner {
        return {
            visAlleVersjoner: async dokumentversjon => {
                await this.visDetaljerFor(this.finnFil(dokumentversjon)!);
                this.dokumentDetaljerKomponent()!.fokuserVersjonerBlokk();
            },

            visSignatarer: async dokumentversjon => this.visSignatarerForDokument(dokumentversjon),

            visSakerArkivdokumentBehandlesI: async dokumentversjon => {
                await this.visDetaljerFor(this.finnFil(dokumentversjon)!);
                this.dokumentDetaljerKomponent()!.fokuserSakerArkivdokumentBehandlesIBlokk();
            },

            visSkjerming: dokumentversjon => this.visSkjermingForDokument(dokumentversjon),

            registrerNyDokumentversjon: dokumentversjon => this.registrerNyDokumentversjon(dokumentversjon),

            tilgjengeligFunksjonalitet: dokumentversjon => {
                return {
                    rediger: kanArkivnodeRedigeres(this.finnFil(dokumentversjon)!.node, this.kontekst.autentisertBruker()),
                    // alle øvrige funksjoner skal alltid være aktive i arkiv
                    behandlesISaker: true,
                    favorittmarkering: true,
                    signering: true,
                    versjonsvisning: true,
                    skjerming: true
                };
            }
        };
    }

    delegerteDokumentvisningOperasjoner(): DelegerteDokumentvisningOperasjoner {
        return {
            visSkjerming: dokumentversjon => this.visSkjermingForDokument(dokumentversjon),
            visSignatarer: dokumentversjon => this.visSignatarerForDokument(dokumentversjon)
        };
    }

    delegerteDokumentDetaljerOperasjoner(): DelegerteDokumentDetaljerOperasjoner {
        return {
            registrerNyDokumentversjon: dokumentversjon => this.registrerNyDokumentversjon(dokumentversjon),

            åpneDokumentInline: dokumentversjon => this.åpneDokumentInline(this.valgtDokument()!)
        };
    }

    delegerteArkivmappeMenyOperasjoner(): DelegerteArkivmappeMenyOperasjoner {
        return {
            visSkjerming: async (arkivmappe: ArkivMappenodeDLM) => this.visSkjermingMappe(arkivmappe),

            nyttDokument: async (arkivmappe: ArkivMappenodeDLM) => {
                //dersom nyttDokument blir kalt på mappen-menyen til mappe som er barn av aktiv mappe må vi sørge for å gjøre denne mappen til aktiv mappe
                this.ekspanderBarnAvAktivMappe(this.finnMappe(arkivmappe)!);
                await this.nyttDokument();
            }
        }
    }

    delegerteMappevisningOperasjoner(): DelegerteMappevisningOperasjoner {
        return {
            visSkjerming: async (arkivmappe: ArkivMappenodeDLM) => this.visSkjermingMappe(arkivmappe)
        };
    }

    //hjelpemetoder

    /** Returnerer strøm av det som til en hver tid er ekspanderte mapper.
     * Starter med å laste rot-mappen, vil så levere en utflatet liste med ekspanderte mapper hver gang bruker velger å ekspandere/kollapse en mappe.
     * Se {@link #ekspandertEndret} */
    private ekspanderteMapper(): Observable<Mappe[]> {
        return this.avhengigheter.rot()
          .pipe(
            switchMap(rotnode => {
                debug('lastRotmappe lastet %o', rotnode)
                this.rotnode = new BrukerRot(rotnode.data, this.avhengigheter);

                //siden avhengigheter.rot() potensielt leverer multiple verdier, og vi kun ønsker å kalle ekspanderStiTil() én gang, gør vi kallet kun når vi får ferske data
                //merk at dette ikke vil fungere i en event offline-modus..
                if (!rotnode.meta.levertFraCache) {
                    //sørge for å vise forespurt mappe, dersom angitt
                    if (erIkkeNil(this.initiellMappeId())) this.ekspanderStiTil(this.initiellMappeId()!);
                    //eller sist viste mappe
                    else if (erIkkeNil(this.avhengigheter.sisteBesøkteMappeId)) this.ekspanderStiTil(this.avhengigheter.sisteBesøkteMappeId!);
                }

                return this.rotnode
                  //leverer verdier hver gang hvilke noder som er ekspandert endres, eller deres barn endres
                  .somUtflatetObserverbar()
                  .pipe(
                    map(noder => noder.filter(node => node.erMappe())), //vi lister kun mapper
                    tap(mapper => this.håndterAktivMappeSlettet()) //håndter at aktiv mappe potensielt ikke lenger er tilgjengelig
                  );
            }),
            takeUntilDestroyed(this.destroyRef)
          );
    }

    private setAktivMappe(mappe: Mappe) {
        this.aktivMappe.set(mappe);
        mappe.fokuser();
        this.skjulDetaljer();
        //merk at dette kun oppdatere URL i nettleser - ingen faktisk navigasjon skjer
        if (!erOrganisasjonsrotMappe(mappe.node)) {
            this.navigasjon.gåTilArkivMappe(mappe.node.id);
            this.avhengigheter.sisteBesøkteMappeId = mappe.node.id;
        }
    }

    private håndterAktivMappeSlettet() {
        if (erNil(this.aktivMappe()) || this.rotnode!.finnNode(this.aktivMappe()!.node.id)) return;

        //finn føreste forelder til aktivMappe som er i settet av tilgjengelige mapper
        const eksisterendeForeldre = this.aktivMappe()!.foreldre().reverse()
          .filter(forelder => this.rotnode!.finnNode(forelder.node.id));
        if (erTomListe(eksisterendeForeldre)) this.ingenMappeValgt()
        else this.togleITreOgVisInnhold(første(eksisterendeForeldre)!);
    }

    /** Blanker ut aktivMappe, fører til at midt-del av vindu blankes ut */
    private ingenMappeValgt() {
        this.aktivMappe.set(null);
        this.skjulDetaljer();
        this.matTree().collapseAll();
    }

    private beregnKanRedigereAktivMappe(): boolean {
        if (erNil(this.aktivMappe()) ||
          (this.aktivMappe() instanceof Rot) || //syntetisk mappe
          (this.aktivMappe() instanceof OrganisasjonsrotMappe)) //syntetisk mappe
            return false;
        return kanArkivnodeRedigeres(this.aktivMappe()!.node, this.kontekst.autentisertBruker());
    }

    /** Meny skal ikke være synlig for brukerrot og organisasjonsrot, forøvrig må bruker har skrivetilgang */
    private beregnKanOppretteNodeIAktivMappe(): boolean {
        if (erNil(this.aktivMappe()) ||
          (this.aktivMappe() instanceof Rot) || //syntetisk mappe
          (this.aktivMappe() instanceof OrganisasjonsrotMappe)) //syntetisk mappe
            return false;
        return kanNyNodeLeggesTil(this.aktivMappe()!.node, this.kontekst.autentisertBruker());
    }

    private async visSkjermingForDokument(dokumentversjon: DokumentVersjonModell) {
        await this.visDetaljerFor(this.finnFil(dokumentversjon)!);
        this.dokumentDetaljerKomponent()!.fokuserSkjermingBlokk();
    }

    private async visSignatarerForDokument(dokumentversjon: DokumentVersjonModell) {
        await this.visDetaljerFor(this.finnFil(dokumentversjon)!);
        this.dokumentDetaljerKomponent()!.fokuserSigneringBlokk();
    }

    private async visSkjermingMappe(arkivmappe: ArkivMappenodeDLM) {
        this.visDetaljerFor(this.finnMappe(arkivmappe)!);
        //i motsetning til for dokumenter er det ikke gitt at arkivmappeDetaljer er synlige når visSkjerming kalles
        setTimeout(() => this.arkivmappeDetaljerKomponent()!.fokuserSkjerming(), 0);
    }

    /** Åpner inline visning av angitt dokument, delegerer til {@link DokumentvisningBasisKomponent#aapneInline}.
     * @return false dersom angitt fil ikke finnes */
    private åpneDokumentInline(fil: Fil, forSignering = false): boolean {
        debug(`åpneDokumentInline ${fil.node.navn}`);
        const dokumentKomp = ([...this.dokumentKortvisninger(), ...this.dokumentListevisninger()] as DokumentvisningBasisKomponent[])
          .find(komponent => komponent.dokumentversjon().id == fil.node.dokument.id);
        if (erNil(dokumentKomp)) {
            console.warn(`ArkivTrevisningKomponent.åpneDokumentInline, fant ikke dokument med id ${fil.node.dokument.id}`);
            return false;
        }
        if (forSignering) dokumentKomp.signer();
        else dokumentKomp.aapneInline();
        return true;
    }

    private async lastOppArkivdokumenter(filer: File[]) {
        verifiserErSann(this.kanOppretteNodeIAktivMappe(), 'ingen aktiv mappe satt som tillater opplasting');
        const opplastinger =  await this.sekvensiellFilopplasting.leggTilFiler(filer);

        //vis info om eventuelle 'nye versjoner' i modal, fortsett så opplasting dersom bruker velger dette
        if (opplastinger.validering.nyeVersjoner.length > 0) {
            const dialog = DokumentOpplastingNyeversjonerDialogKomponent.vis(this.matDialog, opplastinger.validering.nyeVersjoner);
            const fortsett = await firstValueFrom(dialog.afterClosed());
            if (!fortsett) {
                opplastinger.fjern();
                return;
            }
        }

        await this.utførOpplasting(opplastinger);
    }


    private async registrerNyDokumentversjon(dokumentversjon: DokumentVersjonModell) {
        const fil = await this.filvelger.presenterFilvelgerEnkeltfilStandardformat();
        if (erNil(fil)) return;
        const opplastinger =  await this.sekvensiellFilopplasting.leggTilNyDokumentversjon(fil, this.somEksisterendeDokument(this.finnFil(dokumentversjon)!.node));
        await this.utførOpplasting(opplastinger);
    }

    private async utførOpplasting(opplastinger: Opplastinger<ArkivFilnodeModell>) {
        //vis eventuelle valideringsfeil i modal, avbryt så opplasting
        if (opplastinger.validering.harFeil) {
            const dialog = DokumentOpplastingFeilDialogKomponent.visValideringsfeil(this.matDialog, opplastinger.validering);
            await firstValueFrom(dialog.afterClosed());
            opplastinger.fjern();
            return;
            //kunne ha latt bruker velge å laste opp de filene som er 'ok':
        }

        //kun start opplasting dersom ikke allerede startet
        if (this.sekvensiellFilopplasting.opplastingPågårNå) return;
        this.sekvensiellFilopplasting.start()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
              next: httpHendelse => debug('opplasting:hendelse', httpHendelse),
              complete: () => {
                  debug('opplasting:ferdig')
                  this.visEventuellOpplastingerFeiletPgaUgyldigMimetype();
              }
          });
    }

    private visEventuellOpplastingerFeiletPgaUgyldigMimetype() {
        if (erTomListe(this.opplastingerFeiletPgaUgyldigMimetype)) return;
        DokumentOpplastingFeilDialogKomponent.visOpplastingsfeilUgyldigMimetype(this.matDialog, this.opplastingerFeiletPgaUgyldigMimetype);
        this.opplastingerFeiletPgaUgyldigMimetype = [];
    }

    private filopplastingAvhengigheter(): FilopplastingAvhengigheter<ArkivFilnodeModell> {
        return {
            maksFilstørrelse: this.avhengigheter.maksFilstørrelse,
            filKanLeses: fil => filKanLeses(fil),
            vedOpplastingFeilet: (feil, opplasting) => {
                if (erIkkeNil(feil.ugyldigMimetype)) {
                    this.opplastingerFeiletPgaUgyldigMimetype.push({filnavn: opplasting.fil.name, mimetype: feil.ugyldigMimetype});
                    return;
                }
                if (feil.erZscalarFeil) {
                    this.informerBrukerOmOpplastingAvbruttAvZscalar(opplasting.fil.name)
                    return;
                }

                let feilmelding = erIkkeNil(feil.httpFeil) ? standardFeilmeldingerForErrorRespons(feil.httpFeil) : null;
                if (erNil(feilmelding)) feilmelding = new I18nTekst(i18n('Opplasting av {fil} feilet'), {'fil': opplasting.fil.name})
                this.meldingTilBruker.feilmelding(feilmelding, Varighet.timeout, null, false /* ikke skriv til log */);
            },
            registrerNy: fil => this.avhengigheter.opprettArkivdokument(this.aktivMappe()!.node.id, fil),
            registrerNyVersjon: (fil, eksisterende) => this.avhengigheter.opprettArkivdokumentVersjon(eksisterende.id, fil),
            eksisterende: navn => første(this.aktivMappe()!.barn()
              .filter(eksisterende => erFilNode(eksisterende.node))
              .map(eksisterende => eksisterende.node as ArkivFilnodeModell)
              .filter(eksisterende => eksisterende.dokument.filnavn == navn || eksisterende.dokument.pdfFilnavn == navn)
              .map(eksisterende => this.somEksisterendeDokument(eksisterende)))
        }
    }

    private informerBrukerOmOpplastingAvbruttAvZscalar(filnavn: string) {
        return this.dialog.advarsel({
            tittel: this.oversettelser.oversett(i18n('Feil under opplasting av {filnavn}'), {filnavn: filnavn}),
            innhold: this.oversettelser.oversett(i18n('Din organisasjon benytter et system (Zscaler) for å overvåke/begrense informasjonsdeling. Kontakt din IT-ansvarlig for informasjon om opplasting av filer.')),
            droppAvbrytKnapp: true
        });
    }

    private somEksisterendeDokument(arkivfil: ArkivFilnodeModell): EksisterendeDokument<ArkivFilnodeModell> {
        return {
            dokument: arkivfil,
            erSendtTilSignering: arkivfil.dokument.signeringStatus != SigneringStatus.ikkeAktivert
        };
    }

    /**
     * Sørger for å ekspandere stien ned til angitt mappe i node-treet, samt vise innholdet til angitt mappe.
     * Vi har en unødvendig dobbelt-lasting av angitt mappe da vi både laster den i denne metoden, samt når mappen blir ekspandert i
     * node-treet (ifbm mappenode.åpne() kallet).
     */
    private async ekspanderStiTil(mappeId: ArkivnodeId) {
        //lest data fra url da url kan bli endret via indirekte kall til this.mappeValgt() (avhengig av hvilke asynk kall som returnerer først)
        const dokumentId = this.ajsUIRouterGlobals.params['dokumentId'] as DokumentId | null;
        const skalSignere = this.ajsUIRouterGlobals.params['signer'] as boolean;

        debug(`ekspanderStiTil mappeId: ${mappeId}, dokumentId: ${dokumentId}`)
        //last forespurt mappe
        let mappe = await firstValueFrom(this.avhengigheter.mappe(mappeId).pipe(kunRequestRespons(), mapTilData()));
        let sti = stiTilNode(mappe);

        //legg til alle foreldrene i mappe-treet vårt, begynne med å finne grupperoten
        let mappenode = this.rotnode!.finnGrupperotMappe(sti.pop()!) as Mappe | null;
        //traverserer så resterende sti ned til forespurt mappe
        while (erIkkeTomListe(sti) && erIkkeNil(mappenode)) {
            mappenode.åpne(); //åpner noden
            mappenode = mappenode.leggTilBarn(sti.pop()!)[0] as Mappe;
        }
        if (erNil(mappenode)) {
            this.meldingTilBruker.feilmelding(new I18nTekst(i18n('Fant ikke mappen med id {mappeId}'), {mappeId}));
            return;
        }

        //siden vi har lastet mappe med dens barn kan vi nå legge til barna
        mappenode.leggTilBarn(...mappe.barn);
        //vis innholdet i angitt mappe
        this.togleITreOgVisInnhold(mappenode);

        //dersom dokumentId angitt, åpne inlinevisning av dette, men må la valgt mappe rendre først
        if (erNil(dokumentId)) return;
        const fil = mappenode.filer().find(fil => fil.node.dokument.dokumentId == dokumentId)
        debug(`ekspanderStiTil åpne dokument: ${dokumentId}, funnet fil-representasjon:${erIkkeNil(fil)}`)
        if (erIkkeNil(fil)) setTimeout(() => this.åpneDokumentInline(fil, skalSignere), 0);
    }

    /** Returnerer fil-node tilknyttet angitt dokumentversjon, null dersom ikke funnet*/
    private finnFil(dokumentversjon: DokumentVersjonModell): Fil | null {
        return this.rotnode!.finnNode(dokumentversjon.foreldre.arkivfilnodeId!) as Fil;
    }

    /** Returnerer mappe-node tilknyttet angitt mappe, null dersom ikke funnet*/
    private finnMappe(mappe: ArkivMappenodeDLM): Mappe | null {
        return this.rotnode!.finnNode(mappe.id!) as Mappe;
    }
}


/** Virtuell rot-mappe som inneholder et barn per organisasjonsnavn som bruker har tilgang til. */
export class BrukerRot extends Rot<OrganisasjonsrotMappe> {

    /** Oppretter ny BrukerRot populert angitt rot-mappe.
     * Rot-mappen forventes å ha ett innslag i {@link ArkivMappenodeModell#barn} per gruppe bruker har tilgang til.
     * {@link BrukerRot#initBarn} vil så opprette et syntetisk 'organisasjon' mellomnivå mellom BrukerRot og gruppe-mappene i angitt rot. */
    constructor(rot: ArkivMappenodeModell, avhengigheter: ArkivTrevisningKomponentAvhengigheter) {
        super(rot, avhengigheter);
    }

    /** Erstatt node.barn (som nå representerer tilgjengelige grupper) med
     * en mappe per organisasjon som så inneholder de respektive gruppene som barn
     * går altså fra 'rot -> gruppe' til 'rot -> organisasjon -> gruppe' */
    protected override initBarn(gruppeMapper: ArkivNodeModell[]) {
        debug('BrukerRot.initBarn kalt')
        const tilgjengeligeGrupper: EnkelGruppeModell[] = (<ArkivTrevisningKomponentAvhengigheter>this.avhengigheter).tilgjengeligeGrupper();
        const orgMedGrupper = grupperGruppertPåOrganisasjonsnavn(tilgjengeligeGrupper);

        //pakk inn i OrganisasjonsrotMappe, OrganisasjonsrotMappe inneholder liste over tilhørende grupper
        const organisasjonsrøtter = [...orgMedGrupper.values()]
          .map(grupperIOrg => opprettOrganisasjonsrotMappe(grupperIOrg, this.node as ArkivMappenodeModell))
          .map(orgMappe => new OrganisasjonsrotMappe(orgMappe as ArkivMappenodeModell, orgMedGrupper.get(orgMappe.navn)!, this, this.avhengigheter));

        debug('BrukerRot.initBarn', organisasjonsrøtter)
        this.barn.set(organisasjonsrøtter);
    }

    /** Utflatet liste med alle ekspanderte noder, denne noden (BrukerRot) er alltid ekskludert */
    override ekspanderteNoder(): Node[] {
        debug('ekspanderteNoder: %j', this.barn().flatMap(barn => barn.ekspanderteNoder()).map(node => node.node.navn))
        return this.barn().flatMap(barn => barn.ekspanderteNoder());
    }

    /** Returnerer {@link GrupperotMappe} som representerer angitt gruppenode.
     * Sørger for å åpne returnert mappe samt forelderen (OrganisasjonsrotMappe).
     * Forventer at angitt gruppenode har {@link ArkivMappenodeModell#erRotMappe} = true,
     * og at organisasjonsnavn ligger i feltet {@link ArkivMappenodeModell#beskrivelse} */
    finnGrupperotMappe(gruppenode: ArkivMappenodeModell): GrupperotMappe | null {
        const organisasjonsnode = this.barn().find(kandidat => kandidat.inneholderGruppe(gruppenode.eiendeGruppeId));
        if (erNil(organisasjonsnode)) return null;
        organisasjonsnode.åpne();
        const gruppemappe = organisasjonsnode.finnGruppemappe(gruppenode.eiendeGruppeId);
        if (erNil(gruppemappe)) return null;
        gruppemappe.åpne();
        return gruppemappe;
    }

    finnNode(nodeId: ArkivnodeId): Node | null {
        return this.alleNoder().find(node => node.node.id == nodeId) ?? null;
    }
}

/** Representerer en organisasjon, der tilhørende grupper spiller rollen som barn. */
class OrganisasjonsrotMappe extends Mappe<GrupperotMappe> {
    constructor(orgMappe: ArkivMappenodeModell, private grupper: EnkelGruppeModell[], forelder: BrukerRot, avhengigheter: NodeAvhengigheter) {
        super(orgMappe, forelder, avhengigheter);
        this.nivaa = 0; //vi viser ikke foreldren (BrukerRot), OrganisasjonsrotMappe er laveste nivå
        //set barn basert på angitt orgMappe
        this.initBarn(orgMappe.barn);
        this.lastet.set(true);
    }

    /** Returnerer GrupperotMappe for angitt gruppe */
    finnGruppemappe(gruppeId: GruppeId) {
        return this.barn().find(barn => barn.gruppe.id == gruppeId) ?? null;
    }

    /** Sann dersom denne organisasjonsroten inneholder GrupperotMappe for angitt gruppe */
    inneholderGruppe(gruppeId: GruppeId): boolean {
        return erIkkeNil(this.finnGruppemappe(gruppeId));
    }

    //OrganisasjonsrotMappe-node har barn satt i konstruktør - disse må ikke nullstilles
    override lukk() {
        //på sikt bør vi kanskje la være å lukke abon. når node kolapses - neste åpne() vil føre til datarelasting - unødvendig?
        this.ekspandert.set(false);
        this.publiser();
    }

    //OrganisasjonsrotMappe-node har allerede lastet barn (i konstruktør)
    protected override async lastBarn() {
        this.publiser();
    }

    protected override initBarn(gruppeMappe: ArkivNodeModell[]) {
        this.barn.set(gruppeMappe.map(grupperot => {
            const gruppe = this.grupper.find(gruppe => gruppe.id == grupperot.eiendeGruppeId)!;
            return new GrupperotMappe(grupperot as ArkivMappenodeModell, gruppe, this, this.avhengigheter);
        }));
    }

}

/** Representerer en gruppe.
 * Utvider {@link Mappe} med informasjon om {@link #gruppe} denne representerer. */
class GrupperotMappe extends Mappe {
    constructor(mappe: ArkivMappenodeModell, public gruppe: EnkelGruppeModell, forelder: OrganisasjonsrotMappe, avhengigheter: NodeAvhengigheter) {
        super(mappe, forelder, avhengigheter);
    }
}

export type ArkivVisningsmodus = 'liste' | 'kort';

@Injectable()
export class ArkivTrevisningKomponentAvhengigheter implements NodeAvhengigheter {

    private _sisteBesøkteMappeId: ArkivnodeId | null = null;

    constructor(private arkivDatatjeneste: ArkivDatatjeneste,
                private dokumentInformasjonTjeneste: DokumentInformasjonTjeneste,
                private kontekst: BrukerkontekstTilbyder,
                private konfigurasjon: Appkonfigurasjon) {
    }

    get sisteBesøkteMappeId(): ArkivnodeId | null {
        return this._sisteBesøkteMappeId;
    }

    set sisteBesøkteMappeId(value: ArkivnodeId | null) {
        this._sisteBesøkteMappeId = value;
    }

    tilgjengeligeGrupper(): EnkelGruppeModell[] {
        return this.kontekst.autentisertBruker().tilgjengeligeGrupper.map(gruppe => gruppe.gruppe);
    }

    rot(): Observable<DataOgMeta<ArkivMappenodeModell>> {
        return this.arkivDatatjeneste.rotmappeMedMeta();
    }

    mappe(mappedId: ArkivnodeId): Observable<DataOgMeta<ArkivMappenodeModell>> {
        return this.arkivDatatjeneste.mappeMedMeta(mappedId);
    }

    async oppdaterMappe(mappeId: ArkivnodeId, spesifikasjon: OppdaterMappeSpesifikasjon): Promise<void> {
        await this.arkivDatatjeneste.oppdaterMappe(mappeId, spesifikasjon);
    }

    get maksFilstørrelse(): number {
        return this.konfigurasjon.maksFilopplastingStørrelse;
    }

    opprettArkivdokument(mappeId: ArkivnodeId, fil: File): Observable<HttpEvent<ArkivFilnodeModell>> {
        return this.arkivDatatjeneste.opprettArkivdokument(mappeId, fil, Feilhåndteringsstrategi.propagerSomError);
    }

    opprettArkivdokumentVersjon(filId: ArkivnodeId, fil: File): Observable<HttpEvent<ArkivFilnodeModell>> {
        return this.arkivDatatjeneste.opprettArkivdokumentVersjon(filId, fil, Feilhåndteringsstrategi.propagerSomError);
    }

    // NodeAvhengigheter implementasjon

    dokumentinformasjon(dokumentversjon: DokumentVersjonModell): DokumentInformasjon {
        return this.dokumentInformasjonTjeneste.dokumentinformasjon(dokumentversjon);
    }

    barn(forelderId: ArkivnodeId): Observable<DataOgMeta<ArkivNodeModell[]>> {
        return this.arkivDatatjeneste.barnMedMeta(forelderId);
    }
}
